var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyApplications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.947 43.101H13.566C11.155 43.101 9.194 41.14 9.194 38.729V15.003C9.194 12.592 11.155 10.631 13.566 10.631H28.947C31.358 10.631 33.319 12.592 33.319 15.003V38.729C33.319 41.14 31.358 43.101 28.947 43.101Z",
    fill: "#172535"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.691 40.121H16.31C13.899 40.121 11.938 38.16 11.938 35.749V12.022C11.938 9.61099 13.899 7.64999 16.31 7.64999H31.691C34.102 7.64999 36.063 9.61099 36.063 12.022V35.748C36.063 38.159 34.102 40.12 31.691 40.12V40.121Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.435 37.14H19.054C16.643 37.14 14.682 35.179 14.682 32.768V9.042C14.682 6.631 16.643 4.67 19.054 4.67H34.435C36.846 4.67 38.807 6.631 38.807 9.042V32.768C38.807 35.179 36.846 37.14 34.435 37.14Z",
    fill: "#FD6A3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.251 12.485C19.422 12.473 18.741 13.135 18.73 13.964C18.718 14.793 19.38 15.474 20.209 15.485C20.223 15.485 20.237 15.485 20.251 15.485H33.237C34.066 15.497 34.747 14.835 34.758 14.006C34.77 13.177 34.108 12.496 33.279 12.485C33.265 12.485 33.251 12.485 33.237 12.485H20.251Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.251 19.405C19.422 19.393 18.741 20.055 18.73 20.884C18.718 21.713 19.38 22.394 20.209 22.405C20.223 22.405 20.237 22.405 20.251 22.405H33.237C34.066 22.417 34.747 21.755 34.758 20.926C34.77 20.097 34.108 19.416 33.279 19.405C33.265 19.405 33.251 19.405 33.237 19.405H20.251Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.251 26.324C19.422 26.312 18.741 26.974 18.73 27.803C18.718 28.632 19.38 29.313 20.209 29.324C20.223 29.324 20.237 29.324 20.251 29.324H33.237C34.066 29.336 34.747 28.674 34.758 27.845C34.77 27.016 34.108 26.335 33.279 26.324C33.265 26.324 33.251 26.324 33.237 26.324H20.251Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyApplications);
export default __webpack_public_path__ + "static/media/myApplications.1866b3b3b54a9b4f331f00f34d8c028d.svg";
export { ForwardRef as ReactComponent };